<script setup>
import {computed, ref, watch} from 'vue'
import {useComponentsStore} from '@/stores/components'
import api from '@/services/api'

const props = defineProps({
    field: Object,
    item: Object
})

const componentsStore = useComponentsStore()

const tableName = computed(() => {
    return componentsStore.items.find(
        o => o.id === props.field.modulecomponentsID || o.id === props.field.modulecomponentsId
    )?.tableName
})

// Pure Vue 2.7 replacement for useAsyncState
const options = ref([])

watch(
    () => props.field.columnName,
    async (newColumnName) => {
        if (!tableName.value || !newColumnName) {
            options.value = []
            return
        }

        try {
            const obj = await api.post('api/ListingController/getSelectFilterOptions', {
                tableName: tableName.value,
                columnName: newColumnName
            })

            if (obj.data?.length) {
                options.value = [{value: '--unassigned--', text: '-- Unassigned --'}, ...obj.data]
            } else {
                options.value = []
            }
        } catch (err) {
            options.value = []
        }
    },
    {immediate: true}
)
</script>

<template>
    <select
        v-if="options?.length"
        v-model="item.value"
        class="form-select form-select-sm d-inline-block w-auto"
    >
        <option selected disabled value="null">Select&hellip;</option>
        <option v-for="option in options" :key="option.value" :value="option.value">
            {{ option.text }}
        </option>
    </select>
    <small v-else-if="options?.length === 0" class="form-text ms-2 mb-1 fst-italic small">
        No options available
    </small>
</template>